import { useRefreshTokenAuth } from './useRefreshTokenAuth';
import { useRefreshTokenCypress } from './useRefreshTokenCypress';

const useRefreshToken = window.Cypress ? useRefreshTokenCypress : useRefreshTokenAuth;

export { useRefreshToken };
